var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPixisAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_786_21581)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14.5,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14.5,
    r: 11.7798,
    stroke: "#E8E8E8",
    strokeWidth: 0.44046
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5927 12.6034L17.2334 10.8136C17.3717 10.4271 17.6156 10.0947 17.9331 9.86016C18.2505 9.62566 18.6266 9.50009 19.0117 9.5H24.3587C24.509 9.50073 24.6568 9.54079 24.7894 9.61671C24.9221 9.69264 25.0355 9.80214 25.12 9.93577C25.2044 10.0694 25.2573 10.2231 25.2742 10.3837C25.291 10.5442 25.2712 10.7068 25.2166 10.8573L24.5759 12.6034H16.5927ZM16.3955 13.1554L15.2892 16.2488H21.7319C22.1984 16.2057 22.6446 16.0236 23.0203 15.7231C23.3961 15.4225 23.6865 15.0152 23.859 14.5471L24.3708 13.1554H16.3955ZM15.092 16.8L14 19.8529H16.345C16.6161 19.8529 16.8809 19.7646 17.1046 19.5997C17.3282 19.4347 17.5002 19.2009 17.5979 18.9289L18.3632 16.8H15.092Z",
    fill: "url(#paint0_linear_786_21581)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_786_21581",
    x: 0.952641,
    y: 0.73816,
    width: 38.0947,
    height: 38.0947,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.28552
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.52368
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_786_21581"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_786_21581",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_786_21581",
    x1: 19.641,
    y1: 9.10193,
    x2: 19.641,
    y2: 20.2464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F64FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixisAd);
export default __webpack_public_path__ + "static/media/PixisAd.5dfe51b074cffbd97e669f60afbd1e36.svg";
export { ForwardRef as ReactComponent };